<template>
  <div class="list-item-month">
    <div class="item-left">
      <div class="item-left-line"></div>
      <div class="item-left-circle"></div>
    </div>
    <div class="item-right">
      <div style="margin-left: 1rem;font-size: .85rem;line-height: 1.2rem;">
        {{ date.replace(/(.{2})(.{2})/, "$1月$2日") }}
      </div>
      <div class="item-content">
        <div
          v-for="item in getItemList"
          :key="item.id"
          @click="routeToDetail(item)"
          style="border-bottom: 1px solid #dcdcdc;"
          class="van-ellipsis"
        >
          {{ item.title }}
        </div>
        <div
          v-for="item in getLastItem"
          :key="item.id"
          @click="routeToDetail(item)"
          class="van-ellipsis"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      default: ""
    },
    itemList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getItemList() {
      if (this.itemList.length > 0) {
        return this.itemList.slice(0, this.itemList.length - 1);
      }
      return [];
    },
    getLastItem() {
      if (this.itemList.length > 0) {
        return this.itemList.slice(
          this.itemList.length - 1,
          this.itemList.length
        );
      }
      return this.itemList.slice(0, 1);
    }
  },
  methods: {
    routeToDetail(item) {
      this.$emit("routeToDetail", item, this.itemList, this.date);
    }
  }
};
</script>

<style lang="less" scoped>
.list-item-month {
  display: flex;
  width: calc(100% - 3rem);
  padding: 0 1.5rem;

  .item-left {
    position: relative;
    display: flex;
    width: 13px;

    .item-left-line {
      width: 1px;
      margin-left: 8px;
      background: #dcdcdc;
    }
    .item-left-circle {
      position: absolute;
      width: 9px;
      height: 9px;
      margin-top: 10px;
      background-color: #6596f2;
      border: 4px #d7e4fc solid;
      border-radius: 13px;
    }
  }

  .item-right {
    width: 100%;
    margin: 0.4rem;
    font-size: 0.85rem;

    .item-content {
      margin-top: 0.7rem;
      margin-left: 1rem;
      padding: 0.3rem 1rem;
      background: #fff;
      border-radius: 0.47rem;
      box-shadow: 0 0.06rem 0.25rem 0 rgba(22, 68, 152, 0.3);
    }

    div {
      line-height: 2.5rem;
    }
  }
}
</style>
